exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".wrapper {\n  display: flex;\n  align-items: center;\n}\n\n.xip-logo-sizing {\n  width: 167px;\n  padding-top: 3px;\n}\n\n", ""]);

// exports
